import "moment/locale/nl";

import "./index.less";

import { ConfigProvider } from "antd";
import nl from "antd/lib/locale/nl_NL";
import moment from "moment";
import * as momentTZ from "moment-timezone";
import React from "react";
import ReactDOM from "react-dom";
import { ErrorBoundary } from "react-error-boundary";
import { RecoilRoot } from "recoil";

import App from "./App";
import ErrorFallback from "./ErrorFallback";
import reportWebVitals from "./reportWebVitals";

momentTZ.tz.setDefault("Europe/Amsterdam");
moment.locale("nl");

const element = document.getElementById("compare");

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <ConfigProvider locale={nl}>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <App />
        </ErrorBoundary>
      </ConfigProvider>
    </RecoilRoot>
  </React.StrictMode>,
  element
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
